import(/* webpackMode: "eager" */ "/codebuild/output/src3610081591/src/football-trends-face/src/app/global-error.tsx");
